export default __webpack_public_path__ + "static/media/up.00d08185.svg";